import { render } from "./PersonsByContractNewPage.vue?vue&type=template&id=710f8b3c&scoped=true"
import script from "./PersonsByContractNewPage.vue?vue&type=script&lang=js"
export * from "./PersonsByContractNewPage.vue?vue&type=script&lang=js"

import "./PersonsByContractNewPage.vue?vue&type=style&index=0&id=710f8b3c&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\JCXS\\CAAMSNG\\frontend-caams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-710f8b3c"]])

export default __exports__